import gql from "graphql-tag";

// eslint-disable-next-line import/no-default-export
export const REINDEX_DOCUMENT = gql`
	mutation reindexDocument($input: ReindexDocumentInput!) {
		reindexDocument(input: $input) {
			id,
			identifier
		}
	}
`;
